import { durationMinutes, stateMessageKey } from "../../lib/calendar";
import type { CalendarEventApi } from "../../lib/calendar";

/** The summed minutes of a day's timed events as listed (overlaps not merged), and whether any all-day event was left out. */
export function dayEventsTotal(events: CalendarEventApi[]): {
  minutes: number;
  allDayLeftOut: boolean;
} {
  let minutes = 0;
  let allDayLeftOut = false;
  for (const event of events) {
    const own = durationMinutes(event);
    if (own === null) allDayLeftOut = true;
    else minutes += own;
  }
  return { minutes, allDayLeftOut };
}

/** "No events" only when every shown calendar loaded fine; a failed source has its own banner and proves nothing. */
export function dayPanelNotice(input: {
  loading: boolean;
  anySourceFailed: boolean;
  eventCount: number;
}): "loading" | "empty" | null {
  if (input.eventCount > 0) return null;
  if (input.loading) return "loading";
  if (input.anySourceFailed) return null;
  return "empty";
}

type SourceQuery = { isError: boolean; data?: { state: string } | undefined };

/** The banner line for each shown calendar: a failed request, a non-ok state, or nothing. */
export function sourceMessages(input: {
  peopleFailed: boolean;
  person: SourceQuery;
  company: SourceQuery;
  companyShown: boolean;
}): { person: string | null; company: string | null } {
  const of = (q: SourceQuery) =>
    q.isError ? "calendar.loadFailed" : q.data ? stateMessageKey(q.data.state) : null;
  return {
    person: input.peopleFailed || input.person.isError ? "calendar.loadFailed" : of(input.person),
    company: input.companyShown ? of(input.company) : null,
  };
}
